module.exports = __webpack_public_path__ + "img/website-creator-animate.0d0940dd.svg";